<template>
  <div class="section-fundraising" ref="companyValidationPoint">
    <div class="section-description">
      <span>{{ $t(descriptionTextKey) }}</span>
      <v-dialog
        class="mem-dialog"
        v-model="modal"
        :max-width="480"
        overlay-color="#000000"
        overlay-opacity="0.54"
      >
        <template v-slot:activator="{ on, attrs }">
          <span class="modal-link" v-bind="attrs" v-on="on">{{
            $t("charity_description_link")
          }}</span>
        </template>
        <div class="charity-dialog">
          <img
            :src="dialogImageSrc"
            alt="givestar guide"
            class="dialog-content"
            @click="modal = false"
          />
        </div>
      </v-dialog>
    </div>
    <div
      class="list-title"
      v-if="companiesList && companiesList.length"
      :class="{
        'has-error': errors.fundraisingCompany,
      }"
    >
      <span class="title-icon material-icons-outlined"> favorite_border </span>
      <span>{{ $t("checkout_select_a_charity") }}</span>
    </div>
    <div class="charity-select-container mt-6 mb-6" v-if="companiesList && companiesList.length">
      <LightSelect
        :items="companiesList"
        :value="checkoutFundraisingCompany"
        @input="setFundraisingCompany"
        itemText="name"
        itemValue="charityId"
      />
    </div>
    <!-- <div class="charities-list">
      <div
        class="charities-list-item"
        :class="{
          'is-selected':
            checkoutFundraisingCompany.charityId === company.charityId,
        }"
        v-for="(company, index) in companiesList"
        :key="index"
        @click="setFundraisingCompany(company)"
      >
        <img
          v-if="company.hasImage"
          :src="company.logo"
          :alt="company.name"
          class="company-image"
          :title="company.name"
        />
        <div v-else>{{ $t(company.descriptionKey) }}</div>
      </div>
      <div
        class="charities-list-item"
        :class="{ 'is-selected': isNoFundraisingSelected }"
        @click="setFundraisingCompany()"
      >
        <div>{{ $t("charity_select_no_thanks") }}</div>
      </div>
    </div> -->
    <!-- Amount list -->
    <template v-if="showAmountList">
      <div
        class="list-title"
        :class="{ 'has-error': errors.fundraisingAmount }"
        ref="fundraisingValidationPoint"
      >
        <span class="title-icon material-icons"> monetization_on </span>
        <span>{{ $t("checkout_fundraise_target") }}</span>
      </div>
      <div class="list-subline">{{ $t("givestar_note_subline") }}</div>
      <div class="amount-list" :class="{ 'is-disabled': disableAmountList }">
        <div
          class="amount-list-item"
          :class="{
            'is-selected': checkoutFundraisingCompany.total === amount.total,
          }"
          v-for="(amount, index) in amountList"
          :key="index"
          @click="setAmounTarget(amount)"
        >
          <div>{{ amount.total | currency }}</div>
          <div v-if="amount.isPopular" class="item-subline">
            {{ $t("checkout_most_popular") }}
          </div>
        </div>
      </div>
    </template>
    <i18n class="section-subline" :path="privacyPolicyTextKey" tag="span">
      <a :href="countryLinks.privacyPolicyUrl" target="_blank">
        {{ $t("privacy_policy") }}</a
      >
    </i18n>
    <div v-if="showGivestarImage" class="footer-image">
      <img src="https://delphi-production-images-normal-perch.s3.us-west-2.amazonaws.com/checkout/gs_powered_by.png" alt="givestar">
    </div>
  </div>
</template>
<script>
// NOTE: This component made based on GB Checkout region requirements, might need to add chagese for other regions
import { isEmpty } from "lodash";
import { mapGetters, mapMutations, mapActions } from "vuex";
import { appLinksParams } from "@/common/mixins";
import LightSelect from "@/components/LightSelect.vue";
export default {
  components: {
    LightSelect,
  },
  mixins: [appLinksParams],
  data: () => ({
    // noFundraising: false,
    modal: false,
  }),
  props: {
    descriptionTextKey: String,
    privacyPolicyTextKey: String,
    companiesList: Array,
    amountList: Array,
    isNoFundraisingSelected: Boolean,
    errors: Object,
  },
  computed: {
    ...mapGetters(["checkoutRegion", "checkoutFundraisingCompany"]),
    showAmountList() {
      return !isEmpty(this.amountList);
    },
    disableAmountList() {
      return isEmpty(this.checkoutFundraisingCompany);
    },
    dialogImageSrc() {
      if (this.checkoutRegion === "US")
        return "https://delphi-production-images-normal-perch.s3.us-west-2.amazonaws.com/checkout/output.png";
      return "https://delphi-production-images-normal-perch.s3.us-west-2.amazonaws.com/checkout/givestar_guide.png";
    },
    showGivestarImage() {
      // TODO - Add restrictions by region?
      return true;
    },
  },
  watch: {
    "errors.fundraisingCompany": {
      handler(val) {
        if (!val) return;
        this.$refs.companyValidationPoint.scrollIntoView({
          behavior: "smooth",
        });
      },
    },
    // not used (for now)
    "errors.fundraisingAmount": {
      handler(val) {
        if (!val) return;
        if (this.errors.fundraisingCompany) return;
        this.$refs.fundraisingValidationPoint.scrollIntoView({
          behavior: "smooth",
        });
      },
    },
  },
  methods: {
    ...mapActions(["updateCartDetails"]),
    ...mapMutations(["setCheckoutFundraisingCompany"]),
    async setFundraisingCompany(company) {
      // if (
      //   company &&
      //   company.charityId === this.checkoutFundraisingCompany.charityId
      // )
      //   return this.setCheckoutFundraisingCompany({});

      // if (company) {
      //   this.$emit("on-company-change", false);
      //   // this.noFundraising = false;
      //   this.setCheckoutFundraisingCompany(company);
      //   return;
      // }
      // this.$emit("on-company-change", true);
      // // this.noFundraising = true;
      // this.setCheckoutFundraisingCompany({});

      this.setCheckoutFundraisingCompany(company);

      await this.updateCartDetails();
    },
    setAmounTarget(amount) {
      if (this.disableAmountList) return;

      // console.log("Amount", amount);
      this.setCheckoutFundraisingCompany({
        ...this.checkoutFundraisingCompany,
        total: amount.total,
      });

      this.$emit("on-amount-change");
    },
  },
  mounted() {
    if (this.checkoutFundraisingCompany?.charityId != null) {
      return;
    }

    const preselected = (this.companiesList || []).filter(
      (company) => company.preselected && company.charityId != null
    );

    const company =
      preselected.length === 1
        ? preselected[0]
        : this.companiesList.find((company) => company.charityId === null) ||
          {};

    this.setFundraisingCompany(company);
  },
};
</script>
<style lang="scss" scoped>
$mobile-view: 1024px;
.charity-dialog {
  display: flex;
  background-color: #000000;
  .dialog-content {
    width: 100%;
  }
}
.section-fundraising {
  a {
    color: #4f4f4f;
  }
  .section-description {
    margin-bottom: 24px;
    .modal-link {
      margin-left: 4px;
      text-decoration: underline;
      @include cursorPointer;
      @media screen and (max-width: $mobile-view) {
        font-size: 14px;
      }
    }
  }

  .list-title {
    display: flex;
    flex-direction: row;
    align-items: center;
    &.has-error {
      font-weight: 700;
      color: #cf1019;
    }
    .title-icon {
      font-size: 18px;
      margin-right: 12px;
    }
  }
  .list-subline {
    color: #404040;
    font-size: 12px;
    font-weight: 500;
    line-height: 133.4%; /* 16.008px */
    margin-top: 4px;
  }

  .charities-list {
    display: grid;
    grid-template-columns: repeat(3, 154px);
    gap: 8px;
    margin-top: 20px;
    margin-bottom: 24px;
    @media screen and (max-width: $mobile-view) {
      grid-template-columns: 1fr 1fr;
      margin-top: 30px;
      margin-bottom: 26px;
    }
    .charities-list-item {
      position: relative;
      height: 100px;
      @media screen and (max-width: $mobile-view) {
        height: 80px;
      }
      border-radius: 12px;
      border: 1px solid #d8d8d8;
      padding-left: 24px;
      padding-right: 24px;

      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      text-align: center;

      font-size: 12px;
      font-weight: 700;
      line-height: normal;
      text-transform: uppercase;

      @include cursorPointer;
      &.is-selected {
        border-color: #cf1019;
      }
      .company-image {
        // transform: scale(0.2);
        position: absolute;
        max-width: 80%;
        max-height: 80%;
        object-fit: contain;
      }
    }
  }
  .amount-list {
    display: grid;
    grid-template-columns: repeat(auto-fill, 125px);
    gap: 8px;
    margin-top: 20px;
    margin-bottom: 24px;
    @media screen and (max-width: $mobile-view) {
      grid-template-columns: 1fr 1fr;
      margin-top: 30px;
      margin-bottom: 26px;
    }
    &.is-disabled {
      pointer-events: none;
      .amount-list-item {
        opacity: 0.2;
        background-color: #e0e0e0;
      }
    }
    .amount-list-item {
      position: relative;
      height: 100px;
      @media screen and (max-width: $mobile-view) {
        height: 80px;
      }
      border-radius: 12px;
      border: 1px solid #d8d8d8;
      padding-left: 24px;
      padding-right: 24px;

      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;

      font-size: 12px;
      font-weight: 700;
      line-height: normal;
      text-transform: uppercase;

      @include cursorPointer;
      &.is-selected {
        border-color: #cf1019;
      }

      .item-subline {
        margin-top: 4px;
        color: #9d9d9d;
        text-align: center;
        font-size: 8px;
        font-weight: 600;
        letter-spacing: 0.16px;
        text-transform: uppercase;
      }
    }
  }
  .section-subline {
    font-size: 12px;
    line-height: 16px;
  }
  .footer-image {
    margin-top: 12px;
    img {
      max-width: 154px;
    }
  }
}
</style>
